import { FormValue, isPositiveNumber } from 'lib/utils/formValidation';

export const SECONDS_IN_A_DAY = 86400;

export const isValidRecurringInterval = (value: FormValue) =>
  value == null ||
  (isPositiveNumber(value) &&
    Number(value) >= SECONDS_IN_A_DAY &&
    Number(value) <= SECONDS_IN_A_DAY * 365);
